import React from "react";

const OrderSummaryCard = (card) => {
    const cardData = card.card.cardData[0].data;
   

    if (card == null) {
        <div></div>
    }

    if (card != null)
        return (
            <div
                style={{
                    maxWidth: "28rem",
                    margin: "0 auto",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                    borderRadius: "0.5rem",
                }}
            >
                <div style={{ padding: "1.5rem" }}>
                    {/* Logo */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "1.5rem",
                        }}
                    >
                        <img
                            src="https://appcdn.goqii.com/storeimg/19496_1733143307.webp"
                            alt="GOQii Logo"
                            style={{ height: "1rem" }}
                        />
                    </div>

                    {/* Success Icon */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "1.5rem",
                        }}
                    >
                        <div style={{ position: "relative" }}>
                            <img src={cardData.iconImage}
                                style={{
                                    height: "5rem",
                                    width: "5rem",
                                    color: "#10b981",
                                    position: "relative",

                                }}
                            >
                            </img>
                        </div>
                    </div>

                    {/* Confirmation Message */}
                    <div style={{ textAlign: "center", marginBottom: "2rem" }}>
                        <h2
                            style={{
                                fontSize: "1.5rem",
                                fontWeight: "600",
                                color: "#10b981",
                                marginBottom: "1rem",
                            }}
                        >
                            {cardData.pageHeader}
                        </h2>
                        <p style={{ color: "#6b7280", marginBottom: "0.5rem" }}>
                            {cardData.belowIconTitle}
                        </p>
                        <p style={{ color: "#6b7280", fontSize: "0.875rem" }}>
                            {cardData.belowIconSubTitle}
                        </p>
                    </div>

                    {/* Order Details */}
                    <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: "1.5rem" }}>
                        <h3 style={{ fontWeight: "600", marginBottom: "1rem" }}>
                            {cardData.headerLine}
                        </h3>
                        <div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: "0.875rem",
                                }}
                            >
                                <span style={{ color: "#6b7280" }}>Order ID</span>
                                <span style={{ fontWeight: "500" }}>{cardData.orderId}</span>
                            </div>

                            {/* items */}
                            {cardData.cart.map((item, key) => (

                                <div key={key}>
                                    <div
                                        style={{
                                            backgroundColor: "#f9fafb",
                                            padding: "1rem",
                                            borderRadius: "0.5rem",
                                            marginTop: "0.5rem",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginBottom: "0.5rem",
                                            }}
                                        >
                                            <span style={{ fontWeight: "500" }}>
                                                {item.productName}
                                            </span>
                                            <span style={{ fontWeight: "500" }}>₹{item.finalPrice}</span>
                                        </div>
                                        <div style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                                            Fulfilled By: {item.fullfilledBy}
                                        </div>
                                    </div>
                                </div>

                            ))}

                            {/* Price Breakdown */}
                            <div style={{ marginTop: "1rem", fontSize: "0.875rem" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <span style={{ color: "#6b7280" }}>MRP</span>
                                    <span>{decodeURI(cardData.currencySymbol)}{cardData.cartTotal}</span>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        color: "#10b981",
                                    }}
                                >
                                    <span>Applied Discount</span>
                                    <span>-{decodeURI(cardData.currencySymbol)}{cardData.appliedDiscount}</span>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <span style={{ color: "#6b7280" }}>{cardData.unitPriceLabel}</span>
                                    <span>{decodeURI(cardData.unitPriceTotal)}</span>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <span style={{ color: "#6b7280" }}>{cardData.productGstLabel}</span>
                                    <span>{decodeURI(cardData.productGstTotal)}</span>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >

                                    <span style={{ color: "#6b7280" }}>Delivery Charges</span>
                                    <span style={{ color: (!cardData.deliveryCharges || cardData.deliveryCharges == "0" ? "#10b981" : "") }}>{!cardData.deliveryCharges || cardData.deliveryCharges == "0" ? "FREE" : (decodeURI(cardData.currencySymbol) + cardData.deliveryCharges)}</span>
                                </div>
                            </div>

                            {/* Total */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    paddingTop: "1rem",
                                    borderTop: "1px solid #e5e7eb",
                                    fontWeight: "600",
                                }}
                            >
                                <span>Amount Paid</span>
                                <span>{decodeURI(cardData.currencySymbol)}{cardData.amountPaid}</span>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div style={{ marginTop: "2rem" }}>
                        <button
                            style={{
                                width: "100%",
                                backgroundColor: "#10b981",
                                color: "#ffffff",
                                padding: "0.75rem",
                                borderRadius: "0.5rem",
                                fontWeight: "500",
                                cursor: "pointer",
                                marginBottom: "0.75rem",
                                transition: "background-color 0.2s",
                            }}
                            onMouseOver={(e) =>
                                (e.target.style.backgroundColor = "#059669")
                            }
                            onMouseOut={(e) =>
                                (e.target.style.backgroundColor = "#10b981")
                            }
                        >
                            Track Order
                        </button>
                        <button
                            onClick={() => storeHomeNavigation()}
                            style={{
                                width: "100%",
                                backgroundColor: "#f3f4f6",
                                color: "#374151",
                                padding: "0.75rem",
                                borderRadius: "0.5rem",
                                fontWeight: "500",
                                cursor: "pointer",
                                transition: "background-color 0.2s",
                            }}
                            onMouseOver={(e) =>
                                (e.target.style.backgroundColor = "#e5e7eb")
                            }
                            onMouseOut={(e) =>
                                (e.target.style.backgroundColor = "#f3f4f6")
                            }
                        >
                            Continue Shopping
                        </button>
                    </div>
                </div>
            </div>
        );

    const storeHomeNavigation = () => {
        const currentQueryParams = window.location.search;
        window.location.href = `/store_home_page${currentQueryParams}`
    };
};

export default OrderSummaryCard;
